window.AuthToken = {
  fetch: function () {
    Rails.ajax({url: '/app/system/tokens', type: 'POST'})
    // let xhr = new XMLHttpRequest();
    // xhr.open("POST", "/app/system/tokens");

    // xhr.setRequestHeader("Accept", "application/json");
    // xhr.setRequestHeader("Content-Type", "application/json");
    // xhr.send({});
  },
};
